<app-actions-template (OnApply)="onApply()" (OnClose)="onClose()">
  <h2>
    {{ data.title | translate }}
  </h2>
  <p class="mb-20">
    {{ data.message | translate }}
  </p>
</app-actions-template>
